import React from "react";

import { TopbarLogoutIcon } from "../../../assets/icons/iconsProvider";

const LogoutButton = (props) => {
  const { onClick, className } = props;
  return (
    <button className={className} type="button" onClick={onClick}>
      <TopbarLogoutIcon />
      Log Out
    </button>
  );
};

export default LogoutButton;
